import React from 'react';

const ListDivider: React.FC = () => {
  return <div className="bg-gray-300 dark:bg-gray-700 mx-2 h-px" />;
};

export default ListDivider;
